import React, { useState, useRef, useEffect} from "react";
import { MapContainer, TileLayer, FeatureGroup, useMap } from 'react-leaflet';
// import CustomMenuMouse from './Menu/CustomMenuMouse'; 
// import DrawingLineHandler from './Drawing/DrawingLineHandler'; 
import VisibilityRoundedIcon from '@mui/icons-material/VisibilityRounded';
import SwapCallsRoundedIcon from '@mui/icons-material/SwapCallsRounded';
import DeleteIcon from '@mui/icons-material/Delete';
import SettingsInputCompositeIcon from '@mui/icons-material/SettingsInputComposite';
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import AltRouteIcon from '@mui/icons-material/AltRoute';
import DescriptionIcon from '@mui/icons-material/Description';
import SquareFootIcon from '@mui/icons-material/SquareFoot';
import SearchIcon from '@mui/icons-material/Search';
import SettingsInputAntennaIcon from '@mui/icons-material/SettingsInputAntenna';
import { IconButton, Tooltip } from '@mui/material';
// import DialogDescriptionComponent from './Dialog/DialogDescriptionComponent/DialogDescriptionComponent'; 
// import DrawerMenuEditCanton from './Drawer/DrawerEditCanton/DrawerMenuEditCanton'; 
// import DrawerMenuEditSummit from './Drawer/DrawerEditSummit/DrawerMenuEditSummit'; 
//import './styleOpticMap.css';
//import DrawerMenuViewing from "../Optics/Drawer/DrawerViewing/DrawerMenuViewing";
// import {icon100pab, icon3k, icon30k, iconSummit, iconKp, iconPillar, iconManhole, iconCoupling,
//         iconFob, iconCouplingCanton, iconFobCanton, PILLAR_FLAG, WELL_FLAG, COUPLING_FLAG,
//         FOB_FLAG, CONST_HIGHWAY_COUPLING, CONST_CANTON_COUPLING, CONST_HIGHWAY_FOB,
//         CONST_CANTON_FOB, CONST_HIGHWAY_PILLAR, CONST_CANTON_PILLAR, CONST_HIGHWAY_MANHOLE,
//         CONST_CANTON_MANHOLE, PON_BOX_FLAG, iconPonBox, CONST_CANTON_PON_BOX, PON_BOX,
//         WELL, PILLAR,
//         ROLE_MASTER,
//         ROLE_USER,
//         COUPLING,
//         FOB,
//         iconAmplifier,
//         iconOp,
//         iconDividerApc,
//         iconDividerUpc} from './Constants/ConstantsOptics';
import {loadingCanton, loadingRegionsData, loadingAreaData, loadingCity} from"../Optics/LoadingData/LoadingDataTerritory";  
// import {GetHighwayFilter, GetCantonFilter, GetCantonFilterRefresh, GetHighwayFilterRefresh, GetCantonFobFilterRefresh, GetCantonCouplingFilterRefresh, GetCantonWellFilterRefresh, GetCantonPillarFilterRefresh, GetCantonPonBoxFilterRefresh, GetCantonCableFilterRefresh} from './TerritoryFilter/FilterGetTerritory'      
 import CableShowDisplay  from '../Optics/CableDisplay/CableShowDisplay';
// import ModalDeleteComponent from './Modal/ModalDeleteComponent'
// import ModalDescriptionComponent from "./Modal/ModalDescriptionComponent";
// import ModalSearchComponentMap from "./Modal/ModalSearchComponentMap";
// import TerritoryInfo from "./TerritoryFilter/TerritoryInfo";
// import ShowLengthCable from "./Drawing/ShowLengthCable";
import ModalEditingCable from "../Optics/Drawing/ModalEditingCable";
// import GetSwitchesMapLocation from "./TerritoryFilter/GetSwitchesMapLocation";
// import MarkersEditing from "./Markers/MarkersEditing";
// import MarkersViewing from "./Markers/MarkersViewing";
// import MarkersTwoIconViewing from "./Markers/MarkersTwoIconViewing";
// import MarkersEditingCoupling from "./Markers/MarkersEditingCoupling";
// import MarkersEditingFob from "./Markers/MarkersEditingFob";
// import { ROLE_ADMIN, ROLE_ENGINNER } from "./Constants/ConstantsOptics";
import L from 'leaflet';
// import * as turf from '@turf/turf';
// import MarkerPoligonToClick from "./Markers/MarkerPoligonToClick";
// import LinkEditingHighway from "./Drawing/LinkEditingHighway";
  import LinkEditingCanton from "../Optics/Drawing/LinkEditingCanton";

// import { CONST_CANTON, CONST_HIGHWAY } from "./Constants/ConstantsOptics";
// import MarkersEditingPonBox from "./Markers/MarkersEditingPonBox";
// import ShowRuler from "./Drawing/ShowRuler";
import CustomDrawPolyline from "../Optics/Components/CustomDrawPolyline";
// import ModalRouteCableMap from "./Modal/ModalRouteCableMap";
// import MarkersViewingPillar from "./Markers/MarkersViewingPillar";
// import MarkersTwoIconViewingCoupling from "./Markers/MarkersTwoIconViewingCoupling";
// import MarkersTwoIconViewingFob from "./Markers/MarkersTwoIconViewingFob";
// import MarkersViewingPonBox from "./Markers/MarkersViewingPonBox";
// import MarkersViewingAmplifier from "./Markers/MarkersViewingAmplifier";
// import MarkersViewingOp from "./Markers/MarkersViewingOp";
// import ErrorIcon from '@mui/icons-material/Error';
// import ModalFasteningErrors from "./Modal/ModalFasteningErrors";
import 'leaflet-geometryutil';
//import DrawerViewingConstruct from "./DraverConstruction/DrawerViewingConstruct";
import { GetCantonFilter } from "../Optics/TerritoryFilter/FilterGetTerritory";
import { useLocation } from "react-router-dom";
import ProjectInfo from "./Modals/ProjectInfo";
import { GetCantonPoligonWifi, GetWifiPointByIdRefresh, GetWifiPointFilterRefresh } from "./Data/GetWifiTerritory";
import GetHousesMapLocation from "./Territory/GetHousesMapLocation";
//import DrawerEditComponent from "./DraverConstruction/DrawerEditComponent";
import DrawingLineHandler from "../Optics/Drawing/DrawingLineHandler";
import ShowLengthCable from "../Optics/Drawing/ShowLengthCable";
import CustomMenuMouse from "../Optics/Menu/CustomMenuMouse";
import MarkerPoligonToClick from "../Optics/Markers/MarkerPoligonToClick";
import { CONST_CANTON, CONST_CANTON_COUPLING, CONST_CANTON_FOB, CONST_CANTON_PON_BOX, CONST_HIGHWAY_COUPLING, CONST_HIGHWAY_FOB, COUPLING, COUPLING_FLAG, FOB, FOB_FLAG, icon100pab, iconCoupling, iconCouplingCanton, iconFob, iconFobCanton, iconPonBox, iconWifiAp, iconWifiHotspot, PON_BOX, PON_BOX_FLAG, ROLE_ADMIN, ROLE_ENGINNER, WIFI_POINT_FLAG } from "../Optics/Constants/ConstantsOptics";

import DrawerViewingWifi from "./DraverWifi/DrawerViewingWifi";
import DrawerEditWifi from "./DraverWifi/DrawerEditWifi";
import MarkersEditingWifiPoint from "./Marker/MarkersEditingWifiPoint";
import MarkersTwoIconViewingWifiPoint from "./Marker/MarkersTwoIconViewingWifiPoint";
import DescriptionComponentModalWifi from "./Modals/DescriptionModalWifi/DescriptionComponentModalWif";
import MarkersViewingAmplifier from "../Optics/Markers/MarkersViewingAmplifier";
import TerritoryInfoWifi from "./Modals/TerritoryInfoWifi";
import LogWifi from "./Modals/LogWifi";
// import ModalEditingProblemCable from "./Drawing/ModalEditingProblemCable";
// import MarkersViewingProblemCable from "./Markers/MarkersViewingProblemCable";
// import MarkersViewingDivider from "./Markers/MarkersViewingDivider";
// import MarkerPoligonToClickDistance from "./Markers/MarkerPoligonToClickDistance";
// import CustomSnackbar from "./Components/CustomSnackbar";
// import { WriteLineOpticCanton } from "./WriteData/WriteCantonCommunications";



const MainWifiMap = (role) => {


  const [roleId, setRoleId] = useState(localStorage.getItem('roleId'));

  const [polylinePoints, setPolylinePoints] = useState([]);
  const[lineId, setLineId] = useState();
  const polylinesRef = useRef({});
  const [lengthCableEditing, setLengthCableEditing] = useState(0);
  const [lengthCableSegment, setLengthCableSegment] = useState(0);
  const [lineEditing, setLineEditing] = useState([]);
  const [selectedRankCouling, setSelectedRankCoupling] = useState(null);
  const [polyline, setPolyline] = useState(null);
//  const location = useLocation();
//   const { project } = location.state || {};

 const [switches, setSwitches] = useState([]);
 const [showWifiCoverage, setShowWifiCoverage] = useState(true);
 const [showLinePointToPointWifi, setShowLinePointToPointWifi] = useState(true);
 const [showLineSwToPointWifi, setShowLineSwToPointWifi] = useState(true);
 const [showSwitch, setShowSwitch] = useState(true);
 const [showBaseStation, setShowBaseStation] = useState(true);
 const [showStation, setShowStation] = useState(true);
 const [showAp, setShowAp] = useState(true);
 const [showHousesActiv, setShowHousesActiv] = useState(false);
 const [showHousesNoActiv, setShowHousesNoActiv] = useState(false);
 const [showRank3, setShowRank3] = useState(true);
 const [showRank12, setShowRank12] = useState(true);





  //   const [project] = useState(() => {
  //   const key = window.location.hash.substring(1); 
  //   if (key) {
  //     const data = sessionStorage.getItem(key);
  //     return data ? JSON.parse(data) : null;
  //   }
  //   return null;
  // });



  //  const [user, setUser] =  useState(localStorage.getItem('username'));

  // useEffect(() => {
  //   if (project) {
  //     handleClickCanton();
  //     // Используй project.id, project.name и т.д.
  //   }
  // }, []);

  const handlePolylineRef = (id, ref) => {
    polylinesRef.current[id] = ref;
  };

  const[lineMarkerId, setLineMarkerId] = useState();
  const [selectedWifiType, setSelectedWifiType] = useState(null);

  

  //#region ПЕРЕМЕННЫЕ

  //Drawer
  const [openEditCantonDrawer, setOpenEditCantonDrawer] = useState(false);
  const [openEditSummitDrawer, setOpenEditSummitDrawer] = useState(false);
  const [openViewingDrawer, setOpenViewingDrawer] = useState(false);
  const [selectedCanton, setSelectedCanton] = useState([]);
  const [selectedRegoin, setSelectedRegion] = useState(null);
  const [selectedArea, setSelectedArea] = useState(null);
  const [regions, setRegions] = useState([]);
  const [canton, setCanton] = useState([]);
  const selectedRegionRef = useRef(null);
  const [area, setArea] = useState([]);
  const selectedAreaRef = useRef(null);
  const [selectedCity, setSelectedCity] = useState([]);
  const [city, setCity] = useState([]);
  const [selectCityIsСhange, setSelectCityIsСhange] = useState(null);
  const [selectCantonIsСhange, setSelectCantonIsСhange] = useState(null);
  const [highwayTerritory, setHighwayTerritory] = useState(false);
  const [cantonTerritory, setCantonTerritory] = useState(false);
  const [rulerStatus, setRulerStatus] = useState(false);
  const drawnItemsRef = useRef(new L.FeatureGroup());

  // map
  const mapRef = useRef();
  const polylineHandlerRef = useRef(null);

  // modal
  const [openModal, setOpenModal] = useState(false);
  const [statusModalTerritory, setStatusModalTerritory] = useState('');
  const [openModalDelete, setOpenModalDelete] = useState(false);
  const [modalContent, setModalContent] = useState([]);
  const [markerType, setMarkerType] = useState('');
  const [openModalDescription, setOpenModalDescription] = useState(false);
  const [openModalRouteCable, setOpenModalRouteCable] = useState(false);
  const [openModalLog, setOpenModalLog] = useState(false);
  const [openModalSearch, setOpenModalSearch] = useState(false);
  const [openFasteningErrors, setOpenModalFasteningErrors] = useState(false);

  

  // menu
  const [menuPosition, setMenuPosition] = useState(null);
 
  //poligon
  const [housesData, setHousesData] = useState([]);

  // оборудование
  const [switchesData, setSwitchesData] = useState([]);
  const [showPolygonsArea, setShowPolygonsArea] = useState(false);
  const [showPolygonsCanton, setShowPolygonsCanton] = useState(false);
  const [showHouses, setShowHouses] = useState(false);
  

  
  // cable
  const [selectedLineColor, setSelectedLineColor] = useState();
  const [selectedLineWidth, setSelectedLineWidth] = useState();
  const [coordinatesCableLine, setCoordinatesCableLine] = useState([]);
  const [cableOpticId, setCableOpticId] = useState();
  const [cableTypeId, setCableTypeId] = useState();
  const [cableKind, setCableKind] = useState();
  const [isLineDrawing, setIsLineDrawing] = useState(false);
  const [groupedCoordinatesWithColorTypeAndWidth, setGroupedCoordinatesWithColorTypeAndWidth] = useState({});
  const [descriptionOptic, setDescriptionOptic] = useState({});
  const [showLines, setShowLines] = useState(true);
  const [showLines96, setShowLines96] = useState(true);
  const [showLines72, setShowLines72] = useState(true);
  const [showLines64, setShowLines64] = useState(true);
  const [showLines48, setShowLines48] = useState(true);
  const [showLines36, setShowLines36] = useState(true);
  const [showLines24, setShowLines24] = useState(true);
  const [showLines16, setShowLines16] = useState(true);
  const [showLines12, setShowLines12] = useState(true);
  const [showLines8, setShowLines8] = useState(true);
  const [showLines4, setShowLines4] = useState(true);
  const [showLines2, setShowLines2] = useState(true);
  const [showLines1, setShowLines1] = useState(true);
  const [showPonLayer, setShowPonLayer] = useState(false);
  const [showKtvLayer, setShowKtvLayer] = useState(false);
  const [showEtherLayer, setShowEtherLayer] = useState(false);
  
  const [showLineDenomination, setShowLinesDenomination] = useState(false);
  const [lengthCable, setLengthCable] = useState(0);
  const [linePoints, setLinePoints] = useState([]);
  const [showLinesTypeSolid, setShowLinesTypeSolid] = useState(true);
  const [showLinesTypeBasement, setShowLinesTypeBasement] = useState(false);
  const [showLinesTypeLoft, setShowLinesTypeLoft] = useState(false);
  const [showLinesTypeFacade, setShowLinesTypeFacade] = useState(false);
  const [showLinesTypeDashed, setShowLinesTypeDashed] = useState(true);
  const [linkEditing, setLinkEditing] = useState(false);
  const [markerEditing, setMarkerEditing] = useState('');
  const [isComponentСhangeCoor, setIsComponentСhangeCoor] = useState(false);
  const [isComponentСhangeCoorPillar, setIsComponentСhangeCoorPillar] = useState(false);
  const [isComponentСhangeCoorCoupling, setIsComponentChangeCoorCoupling] = useState(false);
  const [isComponentChangeCoorWifi, setIsComponentChangeCoorWifi] = useState(false);
  const [isComponentСhangeCoorPonBox, setIsComponentСhangeCoorPonBox] = useState(false);

  const [linkEditingProblem, setLinkEditingProblem] = useState(false);
  const[lineProblemId, setLineProblemId] = useState();
  const [markerProblemLineCoordinates, setMarkerProblemLineCoordinates] = useState(null);
  const [flagTettytoryEditingProblemLine, setFlagTettytoryEditingProblemLine] = useState('');
  const linkEditingProblemRef = useRef(linkEditingProblem);
  const [problemCableData, setProblemCableData] = useState([]);

  const [visibleNumberPonBox, setVisibleNumberPonBox] = useState(true);


useEffect(() => {
    linkEditingProblemRef.current = linkEditingProblem;
}, [linkEditingProblem]);


  //marker manhole
  const [markersManhole, setManholeMarkers] = useState([]);
  const [coordinatesManhole, setCoordinatesManhole] = useState([]);
  const [manholeMarker, setIsManholeDrawing] = useState(false);
  const [wellData, setWellData] = useState([]);

  //marker Pillar
  const [markersPillar, setPillarMarkers] = useState([]);
  const [coordinatesPillar, setCoordinatesPillar] = useState([]);
  const [pillarMarker, setIsPillarDrawing] = useState(false);
  const [pillarData, setPillarData] = useState([]);  

  //marker Coupling
  const [markersCoupling, setCouplingMarkers] = useState([]);
  const [coordinatesCoupling, setCoordinatesCoupling] = useState([]);
  const [couplingMarker, setIsCouplingDrawing] = useState(false);
  const [couplingLocationData, setCouplingLocationData] = useState([]);

  //marker Fob
  const [markersWifiPoint, setWifiPointMarkers] = useState([]);
  const [coordinatesWifiPoint, setCoordinatesWifiPoint] = useState([]);
  const [wifiMarker, setIsWifiDrawing] = useState(false);
  const [wifiPointLocationData, setWifiPointLocationData] = useState([]);
  const [selectedRankFob, setSelectedRankFob] = useState(null);

 //marker PonBox
  const [markersPonBox, setPonBoxMarkers] = useState([]);
  const [coordinatesPonBox, setCoordinatesPonBox] = useState([]);
  const [ponBoxMarker, setIsPonBoxDrawing] = useState(false);
  const [ponBoxLocationData, setPonBoxLocationData] = useState([]);

  // KTV
  const [ktvAmplifierData, setktvAmplifierData] = useState([]);
  const [ktvOpData, setktvOpData] = useState([]);

  // DIVIDER
  const [dividerData, setDividerData] = useState([]);

  // фильтр
  const [loadingSummit, setLoadingSummit] = useState(false);
  const [loadingCunton, setLoadingCunton] = useState(false);
  const [position, setPosition] = useState([0, 0]); 
//#endregion





  //#region ФИЛЬТР
    // фильтр  
    const [layersVisibility, setLayersVisibility] = useState({
      icon100pab: false,
      iconKp: false,
      icon3k: true,
      icon30k: true,
      iconSummit: true,
    });

    const [layersVisibilityCommunications, setLayersVisibilityCommunications] = useState({
      iconWifi: true,
      switch: true,
      // iconManhole: true,
      // iconCoupling: true,
      // iconFob: true,
      // iconCouplingCanton: true,
      // iconPonBox: true,
      // iconAmplifier: true,
      // iconOp: true,
      // iconDividerApc: true,
      // iconDividerUpc: true,
    });

      useEffect(() => {
        loadingCanton(setCanton); 
      }, []);   
   
    const toggleLayerVisibility = (layer) => {
      setLayersVisibility(prevState => ({
        ...prevState,
        [layer]: !prevState[layer],
        
      }));
    };

    const toggleLayerVisibilityCommunications = (layer) => {
      setLayersVisibilityCommunications(prevState => ({
        ...prevState,
        [layer]: !prevState[layer],
        
      }));
    };

  

    // const handleHousesChange = () => {
    //  // setShowHouses(!showHouses); 
    //   setShowHousesNoActiv(false); 
    //   setShowHousesActiv(false);
    // };

    const handleHousesActivChange = () => {
      setShowHousesActiv(!showHousesActiv); 
    };

    const handleHousesNoActivChange = () => {
      setShowHousesNoActiv(!showHousesNoActiv); 
    };

     const handleSwRank3Change = () => {
      setShowRank3(!showRank3); 
    };

    const handleSwRank12Change = () => {
      setShowRank12(!showRank12); 
    };

    const changeLinkEditing = (id, status, marker) => {
      setPolylinePoints([]);
      setLineId();
      setMarkerEditing('');
      setLinkEditing(status);  

      if (groupedCoordinatesWithColorTypeAndWidth[id]) {
        setLineId(id);
        setMarkerEditing(marker);
        setPolylinePoints(groupedCoordinatesWithColorTypeAndWidth[id].coordinates);
      }
    };

    // Добавляем проблемное место на карту
    const changeLinkEditingMarker = (id, status, flag) => {
      // if (!groupedCoordinatesWithColorTypeAndWidth[id] || !mapRef.current) return;

      // setLineProblemId();
      // setFlagTettytoryEditingProblemLine('');
      // setMarkerProblemLineCoordinates(null);
      // setLinkEditingProblem(status);
      // //setLinkEditing(status);  
      // const map = mapRef.current;
      // const lineData = groupedCoordinatesWithColorTypeAndWidth[id];
  
      // if (!status || !lineData.coordinates || lineData.coordinates.length < 2) return;
  
      // const polyline = L.polyline(lineData.coordinates);
  
      // const customIcon = L.icon({
      //     iconUrl: '/problem.png',
      //     iconSize: [22, 22],
      //     iconAnchor: [11, 11],
      //     popupAnchor: [0, -11]
      // });
  
      // const handleMapClick = (e) => {
      //   if (!linkEditingProblemRef.current) return;
         
      //     const { lat, lng } = e.latlng;
      //     const closestPoint = L.GeometryUtil.closest(map, polyline, L.latLng(lat, lng));
  
      //     if (!closestPoint) return;
  
      //    // Если клик рядом с линией (точность 5м), ставим маркер
      //   const distance = map.distance([lat, lng], closestPoint);
      //   if (distance < 5) {
      //       if (window.currentMarker) {
      //           // Удаляем старый маркер перед созданием нового
      //           map.removeLayer(window.currentMarker);
      //       }

      //       // Создаем новый маркер и обновляем глобальную переменную
      //       window.currentMarker = L.marker(closestPoint, { icon: customIcon }).addTo(map);

      //       setMarkerProblemLineCoordinates({
      //           lat: closestPoint.lat,
      //           lng: closestPoint.lng
      //       });

      //       setFlagTettytoryEditingProblemLine(flag);
      //       setLineProblemId(id);              
      //     }
      // };
  
      // if (status) {
      //     map.on('click', handleMapClick);
      // } else {
      //     map.off('click', handleMapClick);
      //     if (window.currentMarker) {
      //         map.removeLayer(window.currentMarker);
      //         window.currentMarker = null;
      //     }
      // }
  };


  // useEffect(() => {
  //     loadingCanton(setCanton); 
  //     loadingCity(setCity); 
  //   }, []); 

  
    
    async function handleCantonChange(selectedOption) {
      setSelectedCanton(selectedOption.value);
      setSelectCantonIsСhange(selectedOption);
      setSelectedRegion(null);
      setSelectedArea(null);
      setCantonTerritory(true);

      const regionsData = await loadingRegionsData(selectedOption.value);
        if (regionsData) {
            setRegions(regionsData);
        }
  }

    // загрузка веток в селект
    async function handleRegionChange(event) {
      setSelectedRegion(event.target.value);
      const selectedRegion = event.target.value;
      const areaData = await loadingAreaData(selectedRegion);
      if (areaData) {
        setArea(areaData);
      }
    }
    
    async function handleAreaChange(event) {
      setSelectedArea(event.target.value);
    }

    const wifiPointRefresh = () => {
      GetWifiPointFilterRefresh(selectedRegoin, selectedArea, selectedCanton, setWifiPointLocationData, setWifiPointMarkers, setSwitches);
    }; 

    const wifiPointRefreshById = (wifiPointId) => {
          GetWifiPointByIdRefresh( wifiPointId, setWifiPointLocationData);    
    }; 

    // const cantonCouplingRefresh = () => {
    //   GetCantonCouplingFilterRefreshConstruction(setCouplingLocationData, setCouplingMarkers, project.id);
    // }; 

    // const cantonPonBoxRefresh = () => {
    //   GetCantonPonBoxFilterRefreshConstruction(setPonBoxLocationData, setPonBoxMarkers, project.id);
    // }; 

    // const cantonCablaRefresh = () => {
    //   GetCableFilterRefreshConstructor(setGroupedCoordinatesWithColorTypeAndWidth, setDescriptionOptic, handleLineClearMap, project.id);
    // }; 

    //  const cantonCablaByIdRefresh = (highwayLineId) => {
    //    GetCableByIdFilterRefreshConstructor(  highwayLineId, setGroupedCoordinatesWithColorTypeAndWidth,  setDescriptionOptic,  groupedCoordinatesWithColorTypeAndWidth);    
    // }; 
   

    const handleClickCanton = () => {      
          GetCantonPoligonWifi(selectedRegoin, selectedArea, selectedCanton, setCouplingLocationData, setWifiPointLocationData, setGroupedCoordinatesWithColorTypeAndWidth,
               setPosition,setStatusModalTerritory,setDescriptionOptic, setPonBoxLocationData, setHousesData, setSwitches, setLoadingCunton); 
    };


   

    
    // Обновление центра карты
    useEffect(() => {
      if (position[0] !== 0 || position[1] !== 0) {
        mapRef.current?.setView(position, 14);//13
      }
    }, [position]);
//#endregion
    
  //#region DRAWER
  const toggleViewingDrawer = (isOpen) => () => {
      setOpenViewingDrawer(isOpen);   
  }; 

  const toggleEditCantonDrawer = (cantonTerritory, isOpen) => () => {
    if(!cantonTerritory == false && (role.user =="blackfox"  || role.user == "fomkin" || role.user == "wnyroek")){
    //if(!cantonTerritory == false && (role.role == ROLE_ENGINNER || role.role == ROLE_ADMIN)){
       setOpenEditCantonDrawer(isOpen);
    }else{
       setOpenEditCantonDrawer(false);
    }
  }; 

  // const toggleEditSummitDrawer = (highwayTerritory, isOpen) => () => {
  //   if(!highwayTerritory == false && (role.role == ROLE_ENGINNER || role.role == ROLE_ADMIN)){
  //     setOpenEditSummitDrawer(isOpen);
  //   }else{
  //     setOpenEditSummitDrawer(false);
  //   }
  // };  
//#endregion

  //#region MODAL
  const openModalWithContent = (content, markerType) => {
    setModalContent(content);
    setMarkerType(markerType);
    setOpenModal(true);
   
  };

  // const openModalDeleteComponents = () => {
  //   if(role.role == ROLE_ENGINNER || role.role == ROLE_ADMIN){
  //     setOpenModalDelete(true);
  //   }else{
  //     setOpenModalDelete(false);
  //   }
   
  // };
  
  // const openModalDescriptionComponents = () => {
  //   if(role.role == ROLE_ENGINNER || role.role == ROLE_ADMIN || role.role == ROLE_MASTER || role.role == ROLE_USER){
  //     setOpenModalDescription(true);
  //   }else{
  //     setOpenModalDescription(false);
  //   }
  // }; 

  // const openModalRouteOptic = () => {
  //   if(role.role == ROLE_ENGINNER || role.role == ROLE_ADMIN || role.role == ROLE_MASTER || role.role == ROLE_USER){
  //     setOpenModalRouteCable(true);
  //   }else{
  //     setOpenModalRouteCable(false);
  //   }
  // }; 

  // const openModalSearchComponents = () => {
  //   if(role.role == ROLE_ENGINNER || role.role == ROLE_ADMIN || role.role == ROLE_MASTER || role.role == ROLE_USER){
  //     setOpenModalSearch(true);
  //   }else{
  //     setOpenModalSearch(false);
  //   }
  // };

  // const openModalFasteningErrors = () => {
  //   if(role.role == ROLE_ENGINNER || role.role == ROLE_ADMIN){
  //     setOpenModalFasteningErrors(true);
  //   }else{
  //     setOpenModalFasteningErrors(false);
  //   }
  // };

  const toggleModalLog = (isOpen) => () => {
      if(roleId == ROLE_ENGINNER || roleId == ROLE_ADMIN){
         setOpenModalLog(isOpen);
      }else{
        setOpenModalLog(false);
      }
    }; 



  // const toggleRuler = (isOpen) => () => {
  //   if(role.role == ROLE_ENGINNER || role.role == ROLE_ADMIN || role.role == ROLE_MASTER || role.role == ROLE_USER){
  //      setRulerStatus(isOpen);
  //   }else{
  //     setRulerStatus(false);
  //   }
  // }; 
//#endregion

  //#region MENU
  const handleContextMenu = (event) => {
    event.preventDefault();
    setMenuPosition({ top: event.pageY, left: event.pageX });
  };

  const handleClose = () => {
    setMenuPosition(null);
  };
  //#endregion

  //#region РИСОВАНИЕ
    const handleStartDrawing = () => {
      setIsLineDrawing(true);
    };











    const handleStopDrawing = () => {
        setIsLineDrawing(false);
    };


    const handleSectorCheckboxChange = () => {
      setShowWifiCoverage(!showWifiCoverage); 
    };

    const handleLinePointToPointWifiCheckboxChange = () => {
      setShowLinePointToPointWifi(!showLinePointToPointWifi); 
    };

    const handleLineSwToPointWifiCheckboxChange = () => {
      setShowLineSwToPointWifi(!showLineSwToPointWifi); 
    };

    const handleSwitchCheckboxChange = () => {
      setShowSwitch(!showSwitch); 
    };

     const handleBaseStationCheckboxChange = () => {
      setShowBaseStation(!showBaseStation); 
    };

     const handleStationCheckboxChange = () => {
      setShowStation(!showStation); 
    };

     const handleApCheckboxChange = () => {
      setShowAp(!showAp); 
    };

    
    
    

  //   const handleStopDrawing = () => {    
  //       setIsLineDrawing(false);

  //         // Проверяем, что функция handleCableSave передана и вызываем её
  //   if (handleCableSaveRef) {
  //     handleCableSaveRef();
  // }
  //   };

    // const handleStopDrawing = () => {
     
    //   setIsLineDrawing(false);
    //   if (handleCableSaveRef.current) {
    //     handleCableSaveRef.current(); // Вызываем метод сохранения
    //   }
    // };
   
  //#endregion

  //#region КАБЕЛЬ

  

  useEffect(() => {  
    if (linePoints.length < coordinatesCableLine.length) {
      setCoordinatesCableLine((prevCoordinates) => {
        const newCoordinates = prevCoordinates.slice(0, -1);
        return newCoordinates;
      });
    }
  }, [linePoints]); 

  const updateLength = (points) => {
    let totalLength = 0; 

    for (let i = 0; i < points.length - 1; i++) {
      const point1 = L.latLng(points[i]);
      const point2 = L.latLng(points[i + 1]);
      totalLength += point1.distanceTo(point2);
    }
    setLengthCable(totalLength.toFixed(2));
  };


  // const handleCableSelectChange = (event) => {
  //   const selectedColor = event.target.value;
  //   const [id,color, width, name, fiberQuantity] = selectedColor.split(',');
  //   setCableOpticId(id);
  //   setSelectedLineColor(color);
  //   setSelectedLineWidth(width);
  // };

  
 
  //#endregion
  
 //#region КОЛОДЕЦ

  //marker колодец

 
//#endregion

//#region ОПОРА

 
//#endregion

 //#region МУФТА

 
//#endregion

//#region ФОБ

  const toggleWifiMarker = () => {
    setIsWifiDrawing(!wifiMarker);
  };

  const removeWifiPointMarker = (index) => {
      const newWifiMarkers = markersWifiPoint.filter((marker, idx) => idx !== index);
      const newWifiCoordinates = coordinatesWifiPoint.filter((coordinate, idx) => idx !== index);
      setWifiPointMarkers(newWifiMarkers);
      setCoordinatesWifiPoint(newWifiCoordinates);    
  }; 
 //#endregion

 //#region Pon-box

 
//#endregion

 



const handleChangeWifiType = (event) => {
 const selectedType = event.target.value;
 setSelectedWifiType(selectedType);
};



const enableRuler = () => {
  if (mapRef.current) {
    const map = mapRef.current;

    if (polylineHandlerRef.current) {
      return; 
    }

    if (!map.hasLayer(drawnItemsRef.current)) {
      map.addLayer(drawnItemsRef.current); 
    }

  
    const polylineHandler = new CustomDrawPolyline(map, {
      shapeOptions: {
        color: '#172c85',
        weight: 4
      }
    });

   
    polylineHandlerRef.current = polylineHandler;
    polylineHandler.enable();

    
    map.on('draw:created', (e) => {
      const layer = e.layer;
      if (layer instanceof L.Polyline) {
        drawnItemsRef.current.addLayer(layer); 
      }

      if (polylineHandlerRef.current) {
        polylineHandlerRef.current.disable(); 
        polylineHandlerRef.current = null; 
      }
    });
  }
};




const resetRuler = () => {
  if (drawnItemsRef.current) {
    drawnItemsRef.current.clearLayers(); 
  }

  if (polylineHandlerRef.current) {
    polylineHandlerRef.current.disable(); 
    polylineHandlerRef.current = null; 
  }
};

useEffect(() => {
  if (mapRef.current) {
    const map = mapRef.current;
    if (!map.hasLayer(drawnItemsRef.current)) {
      map.addLayer(drawnItemsRef.current); 
    }
  }
}, []);

// очищаем карту
const handleClearMap2 = () => {
  const map = mapRef.current; // Получаем объект карты
  if (map) {
    // Удаляем все пользовательские слои
    map.eachLayer((layer) => {
      if (!(layer instanceof L.TileLayer)) {
        map.removeLayer(layer);
      }
    });
  }
};

const removeLineFromMap = (highwayLineId) => {
  // Пройдись по ссылкам к слоям карты и удали нужную по id
  // Например, если ты используешь Leaflet:
  const layer = mapRef.current[highwayLineId];
  if (layer) {
    mapRef.removeLayer(layer);
    delete mapRef.current[highwayLineId];
  }
};


const handleLineClearMap = async () => {
   setGroupedCoordinatesWithColorTypeAndWidth([]);
      setDescriptionOptic({});
      setLinePoints([]);
      setCoordinatesCableLine([]);
      setPolylinePoints([]);
      setLineEditing([]);
      setPolyline(null);
  // const map = mapRef.current;
  // if (map) {
  //   const layersToRemove = [];
  //   map.eachLayer((layer) => {
  //     if (layer instanceof L.Polyline && !(layer instanceof L.Polygon)) {
  //       layersToRemove.push(layer);
  //     }
  //   });

  //   layersToRemove.forEach((layer) => {
  //     map.removeLayer(layer);
  //   });

  //   // Подождите пока слои будут удалены (если нужно)
  //   return Promise.resolve();
 // }
};

const handleLineClearMapTEST = (highwayLineId) => {
   setGroupedCoordinatesWithColorTypeAndWidth(prev => {
    const updated = { ...prev };
    delete updated[highwayLineId];
    return updated;
  });

  setDescriptionOptic(prev => prev.filter(item => item.highwayLineId !== highwayLineId));
      setLinePoints([]);
      setCoordinatesCableLine([]);
      setPolylinePoints([]);
      setLineEditing([]);
      setPolyline(null);
}








  return (
    
    <div className="divMainOptic" >

      <div style={{ display: 'flex', height: '100vh' }} onContextMenu={handleContextMenu} >
        <div style={{ flexGrow: 0, display: 'flex', flexDirection: 'column' }}>

          <Tooltip title="Территория / Фильтр" arrow>
            <IconButton onClick={toggleViewingDrawer(true)}>
              <VisibilityRoundedIcon />
            </IconButton>
          </Tooltip>
          <hr style={{margin: "0px"}}/>

          <Tooltip title="Внести Wi-Fi" arrow>
            <IconButton onClick={toggleEditCantonDrawer(cantonTerritory, true)}>
              <SettingsInputAntennaIcon />
            </IconButton>
          </Tooltip>

           <hr style={{margin: "0px"}}/>
              <Tooltip title="Логи" arrow>
                 <IconButton onClick={toggleModalLog(true)}>
                   <FormatListNumberedIcon/>
                 </IconButton>
              </Tooltip>
        
        </div>
        <DrawerEditWifi
          openEditCantonDrawer={openEditCantonDrawer}
          toggleEditCantonDrawer={toggleEditCantonDrawer}
          toggleWifiMarker={toggleWifiMarker}
          wifiMarker={wifiMarker}
          coordinatesWifiPoint={coordinatesWifiPoint}
          setCoordinatesWifiPoint={setCoordinatesWifiPoint}
          user={role.user}
          highwayTerritory={cantonTerritory}
          handleChangeWifiType={handleChangeWifiType}
          selectedWifiType={selectedWifiType}
          setSelectedWifiType={setSelectedWifiType}
          wifiPointRefresh={wifiPointRefresh}
        />
      
        <DrawerViewingWifi
          openViewingDrawer={openViewingDrawer}
          toggleViewingDrawer={toggleViewingDrawer}
          loadingCunton={loadingCunton}
          canton={canton}
          handleCantonChange={handleCantonChange}
          handleRegionChange={handleRegionChange}
          selectedRegionRef={selectedRegionRef}
          regions={regions}  
          handleAreaChange={handleAreaChange}
          selectedAreaRef={selectedAreaRef}
          area={area}
          handleClickCanton={handleClickCanton}
          selectCantonIsСhange={selectCantonIsСhange}
          selectedRegoin={selectedRegoin}
          selectedArea={selectedArea}
          handleSectorCheckboxChange={handleSectorCheckboxChange}
          showWifiCoverage={showWifiCoverage}
          handleLinePointToPointWifiCheckboxChange={handleLinePointToPointWifiCheckboxChange}
          showLinePointToPointWifi={showLinePointToPointWifi}
          handleLineSwToPointWifiCheckboxChange={handleLineSwToPointWifiCheckboxChange}
          showLineSwToPointWifi={showLineSwToPointWifi}
          handleSwitchCheckboxChange={handleSwitchCheckboxChange}
          showSwitch={showSwitch}
          handleBaseStationCheckboxChange={handleBaseStationCheckboxChange}
          showBaseStation={showBaseStation}
          handleStationCheckboxChange={handleStationCheckboxChange}
          showStation={showStation}
          handleApCheckboxChange={handleApCheckboxChange}
          showAp={showAp}
          handleHousesActivChange={handleHousesActivChange}
          showHousesActiv={showHousesActiv}
          handleHousesNoActivChange={handleHousesNoActivChange}
          showHousesNoActiv={showHousesNoActiv}
          handleSwRank3Change={handleSwRank3Change}
          showRank3={showRank3}
          handleSwRank12Change={handleSwRank12Change}
          showRank12={showRank12}
        /> 

         {/* div отображение выбранной территории */}
        <TerritoryInfoWifi
          cantonTerritory={cantonTerritory}
          selectedCity={selectedCity}
          selectedCanton={selectedCanton}
          selectedRegion={selectedRegoin}
          selectedArea={selectedArea}
          wifiPointLocationData={wifiPointLocationData}
          //handleEditingCancelClick={handleEditingCancelClick}
        />
        
     

<MapContainer
  center={[50.45520283095744, 30.441991232620772]}
  zoom={6}
  minZoom={12}
  style={{ flex: '1', borderRadius: '10px' }}
  ref={mapRef}
  whenCreated={(mapInstance) => { mapRef.current = mapInstance; }}
>

<TileLayer
  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
  attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
  maxZoom={19.5} 
/>

         {/* рисуем оборудку */}   
          <GetHousesMapLocation
          layersVisibility={layersVisibility}
          isLineDrawing={isLineDrawing}
          mapRef={mapRef}
          cantonTerritory={cantonTerritory}
          showPolygonsCanton={showPolygonsCanton}
          showPolygonsArea={showPolygonsArea} 
          //   showPolygonsCanton={true}
          // showPolygonsArea={true}   
          housesData={housesData}
          showHouses={showHouses} 
          showHousesActiv={showHousesActiv}
          showHousesNoActiv={showHousesNoActiv}
          showRank3={showRank3}
          showRank12={showRank12}
        />    
       
         {/* Fob в режиме редактирования */}
         <MarkerPoligonToClick
          switchesData={switchesData} 
          marker={wifiMarker}
          markers={markersWifiPoint}
          setMarkers={setWifiPointMarkers}
          coordinates={coordinatesWifiPoint}
          setCoordinates={setCoordinatesWifiPoint}
          selectedCanton={selectedCanton}
          housesData={housesData}
        /> 

       <MarkersEditingWifiPoint
        markers={markersWifiPoint}
        selectedRankFob={selectedWifiType}
        removeMarker={removeWifiPointMarker}
        type={WIFI_POINT_FLAG}
      /> 

       

      {/*  Отображение WifiPoins */}
      <MarkersTwoIconViewingWifiPoint
        data={wifiPointLocationData}
        layersVisibilityCommunications={layersVisibilityCommunications.iconWifi}
        isLineDrawing={isLineDrawing}
        flag={wifiMarker}
        openModalWithContent={openModalWithContent}
        statusModalTerritory={statusModalTerritory}
        highwayFlag={CONST_HIGHWAY_FOB}
        cantonFlag={CONST_CANTON_FOB}
        isComponentChangeCoor={isComponentChangeCoorWifi}
        setIsComponentChangeCoor={setIsComponentChangeCoorWifi}
        switches={switches} 
        user={role.user}
        type={WIFI_POINT_FLAG}
        showWifiCoverage={showWifiCoverage}
        showLinePointToPointWifi={showLinePointToPointWifi}
        showLineSwToPointWifi={showLineSwToPointWifi}
        showSwitch={showSwitch}
        showBaseStation={showBaseStation}
        showStation={showStation}
        showAp={showAp}
        refresh={wifiPointRefreshById}
      />     
     

  </MapContainer>
</div>

      {/* Описание компонентов DialogDescription */}
      <DescriptionComponentModalWifi 
        open={openModal}
        onClose={() => setOpenModal(false)}
        content={modalContent} 
        markerType={markerType}
        isLineDrawing={isLineDrawing}
        wifiMarker={wifiMarker}
        wifiPointRefreshById={wifiPointRefreshById}
        setIsComponentChangeCoorWifi={setIsComponentChangeCoorWifi}       
      />

     
      {/* Отображение Логов */}
       <LogWifi
          open={openModalLog}
          onClose={() => setOpenModalLog(false)}
          user={role.user}
        />
        
    </div>
  );
}

export default MainWifiMap;
